module.exports = __webpack_public_path__ + "static/media/42-3.8b331e2b.mp3";